import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成 条件搜索时候 请把条件安好后台定制的结构体字段 放到 this.searchInfo 中即可实现条件搜索

import { getApiById, getApiList, createApi, updateApi, deleteApi as _deleteApi } from "@/api/api";
import infoList from "@/mixins/infoList";
import { toSQLLine } from "@/utils/stringFun";
var methodOptions = [{
  value: "POST",
  label: "创建",
  type: "success"
}, {
  value: "GET",
  label: "查看",
  type: ""
}, {
  value: "PUT",
  label: "更新",
  type: "warning"
}, {
  value: "DELETE",
  label: "删除",
  type: "danger"
}];
export default {
  name: "Api",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getApiList,
      dialogFormVisible: false,
      dialogTitle: "新增Api",
      form: {
        path: "",
        apiGroup: "",
        method: "",
        description: ""
      },
      methodOptions: methodOptions,
      type: "",
      rules: {
        path: [{
          required: true,
          message: "请输入api路径",
          trigger: "blur"
        }],
        apiGroup: [{
          required: true,
          message: "请输入组名称",
          trigger: "blur"
        }],
        method: [{
          required: true,
          message: "请选择请求方式",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "请输入api介绍",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    // 排序
    sortChange: function sortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (prop) {
        this.searchInfo.orderKey = toSQLLine(prop);
        this.searchInfo.desc = order == "descending";
      }
      this.getTableData();
    },
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    initForm: function initForm() {
      this.$refs.apiForm.resetFields();
      this.form = {
        path: "",
        apiGroup: "",
        method: "",
        description: ""
      };
    },
    closeDialog: function closeDialog() {
      this.initForm();
      this.dialogFormVisible = false;
    },
    openDialog: function openDialog(type) {
      switch (type) {
        case "addApi":
          this.dialogTitlethis = "新增Api";
          break;
        case "edit":
          this.dialogTitlethis = "编辑Api";
          break;
        default:
          break;
      }
      this.type = type;
      this.dialogFormVisible = true;
    },
    editApi: function editApi(row) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getApiById({
                id: row.ID
              });
            case 2:
              res = _context.sent;
              _this.form = res.data.api;
              _this.openDialog("edit");
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    deleteApi: function deleteApi(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this2.$confirm("此操作将永久删除所有角色下该api, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var res;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _deleteApi(row);
                    case 2:
                      res = _context2.sent;
                      if (res.code == 0) {
                        _this2.$message({
                          type: "success",
                          message: "删除成功!"
                        });
                        if (_this2.tableData.length == 1) {
                          _this2.page--;
                        }
                        _this2.getTableData();
                      }
                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }))).catch(function () {
                _this2.$message({
                  type: "info",
                  message: "已取消删除"
                });
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this3.$refs.apiForm.validate( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(valid) {
                  var res, _res;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!valid) {
                          _context4.next = 20;
                          break;
                        }
                        _context4.t0 = _this3.type;
                        _context4.next = _context4.t0 === "addApi" ? 4 : _context4.t0 === "edit" ? 11 : 18;
                        break;
                      case 4:
                        _context4.next = 6;
                        return createApi(_this3.form);
                      case 6:
                        res = _context4.sent;
                        if (res.code == 0) {
                          _this3.$message({
                            type: "success",
                            message: "添加成功",
                            showClose: true
                          });
                        }
                        _this3.getTableData();
                        _this3.closeDialog();
                        return _context4.abrupt("break", 20);
                      case 11:
                        _context4.next = 13;
                        return updateApi(_this3.form);
                      case 13:
                        _res = _context4.sent;
                        if (_res.code == 0) {
                          _this3.$message({
                            type: "success",
                            message: "编辑成功",
                            showClose: true
                          });
                        }
                        _this3.getTableData();
                        _this3.closeDialog();
                        return _context4.abrupt("break", 20);
                      case 18:
                        _this3.$message({
                          type: "error",
                          message: "未知操作",
                          showClose: true
                        });
                        return _context4.abrupt("break", 20);
                      case 20:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  },
  filters: {
    methodFiletr: function methodFiletr(value) {
      var target = methodOptions.filter(function (item) {
        return item.value === value;
      })[0];
      // return target && `${target.label}(${target.value})`
      return target && "".concat(target.label);
    },
    tagTypeFiletr: function tagTypeFiletr(value) {
      var target = methodOptions.filter(function (item) {
        return item.value === value;
      })[0];
      return target && "".concat(target.type);
    }
  },
  created: function created() {
    this.getTableData();
  }
};